// Pagina de certificări FemiEko: alegerea categoriei și fereastra cu datele fiecărui document.
if (!customElements.get('fe-cert-library')) {
  customElements.define('fe-cert-library', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.root = this.closest('.fecert');
      this.buttons = [...this.querySelectorAll('[data-family]')];
      this.families = [...this.querySelectorAll('.family')];
      this.picker = this.querySelector('#category-select');
      this.dialog = this.querySelector('#document-dialog');
      if (!this.families.length || !this.dialog) return;
      this.current = 0;
      this.activeDocument = 0;
      this.activeFamily = '';
      this.trigger = null;
      this.reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.buttons.forEach((b) => b.addEventListener('click', () => this.select(b.dataset.family, true), { signal }));
      this.picker?.addEventListener('change', () => this.select(this.picker.value, true), { signal });
      this.querySelector('.previous')?.addEventListener('click', () => this.select(this.families[(this.current + this.families.length - 1) % this.families.length].id, true), { signal });
      this.querySelector('.next')?.addEventListener('click', () => this.select(this.families[(this.current + 1) % this.families.length].id, true), { signal });
      window.addEventListener('hashchange', () => this.select(location.hash.slice(1)), { signal });

      this.querySelectorAll('[data-document]').forEach((tile) => tile.addEventListener('click', () => {
        this.trigger = tile;
        const family = tile.dataset.document.split(':')[0];
        this.show(family, [...this.querySelectorAll('#' + family + ' [data-document]')].indexOf(tile));
      }, { signal }));
      this.querySelector('.close-document').addEventListener('click', () => this.dialog.close(), { signal });
      this.querySelector('#document-prev').addEventListener('click', () => this.show(this.activeFamily, this.activeDocument - 1), { signal });
      this.querySelector('#document-next').addEventListener('click', () => this.show(this.activeFamily, this.activeDocument + 1), { signal });
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('dialog-open');
        this.trigger?.focus({ preventScroll: true });
      }, { signal });

      this.select(this.families.some((p) => p.id === location.hash.slice(1)) ? location.hash.slice(1) : this.families[0].id);
      this.root?.classList.add('enhanced');
    }

    disconnectedCallback() {
      this.abort?.abort();
      document.body.classList.remove('dialog-open');
    }

    select(id, move = false) {
      const index = this.families.findIndex((p) => p.id === id);
      if (index < 0) return;
      this.current = index;
      this.families.forEach((p) => { p.hidden = p.id !== id; });
      this.buttons.forEach((b) => {
        const active = b.dataset.family === id;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', String(active));
        b.setAttribute('aria-controls', b.dataset.family);
      });
      if (this.picker) this.picker.value = id;
      if (move) {
        history.replaceState(null, '', '#' + id);
        if (!matchMedia('(max-width: 540px)').matches) {
          this.querySelector('#title-' + id)?.focus({ preventScroll: true });
          this.querySelector('#evidence').scrollIntoView({ behavior: this.reduced() ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }

    show(family, index) {
      this.activeFamily = family;
      const tiles = [...this.querySelectorAll('#' + family + ' [data-document]')];
      if (!tiles.length) return;
      this.activeDocument = (index + tiles.length) % tiles.length;
      const tile = tiles[this.activeDocument];
      const reportIndex = Number(tile.dataset.document.split(':')[1]);
      const report = this.querySelectorAll('#' + family + ' .report')[reportIndex];
      if (!report) return;
      this.querySelector('#document-title').textContent = report.querySelector('summary strong').textContent;
      this.querySelector('#document-type').textContent = report.querySelector('summary small').textContent;
      this.querySelector('#document-body').replaceChildren(report.querySelector('.report-body').cloneNode(true));
      const logo = tile.querySelector('img');
      this.querySelector('#document-logo').replaceChildren(...(logo ? [logo.cloneNode(true)] : []));
      this.querySelector('#document-count').textContent = (this.activeDocument + 1) + ' / ' + tiles.length;
      if (!this.dialog.open) { this.dialog.showModal(); document.body.classList.add('dialog-open'); }
      this.dialog.scrollTop = 0;
    }
  });
}
